import React, { useMemo } from 'react'
import { SearchTree } from '@ow/comps'
import { useTbViewStore } from '@vt/hooks'
import { pick, uniq, without } from 'lodash-es'
import { listToTree } from '@ow/utils'

/**
 * 树组件
 * @param {array} tbData 原始数据
 * @param {number = 10} titleLength 标题长度
 * @param {function} otherTitle 标题其他内容
 * @param {boolean = true} selectable 是否可以点击
 * @param {boolean = false} checkable 是否可以勾选
 */

const LeftTree = function ({
  tbData,
  titleLength = 10,
  otherTitle,
  selectable = true,
  checkable = false,
  checkStrictly,
}) {
  const { setClickedInfo, clickedInfo, setSelectedIds, selectedIds } =
    useTbViewStore((state) =>
      pick(state, [
        'setClickedInfo',
        'clickedInfo',
        'setTbData',
        'setSelectedIds',
        'selectedIds',
      ])
    )

  const { selectedKeys = [] } = clickedInfo

  const treeData = useMemo(() => {
    return listToTree(
      tbData.map((v) => {
        return { ...v, id: v.objectId }
      })
    )
  }, [tbData])

  const onCheck = (key, info) => {
    const { checkedNodes, checked, node } = info
    // 删除时
    if (checkStrictly) {
      if (node.children?.length) {
        // 选中父节点时，获取该分支上所有key
        const branch = []
        const findKey = (n) => {
          n.children?.forEach(findKey)
          branch.push(n.key)
        }
        findKey(node)
        if (checked) {
          // 全选该分支上的节点
          setSelectedIds(uniq([...branch, ...key.checked]))
        } else {
          const { parentsId } = node.extData
          // 取消该分支上的节点，取消父级节点
          setSelectedIds(without(key.checked, ...branch, ...parentsId))
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (checked) {
          setSelectedIds(key.checked)
        } else {
          // 取消叶子节点时，取消所有父级节点
          const { parentsId } = node.extData
          setSelectedIds(without(key.checked, ...parentsId))
        }
      }
    } else {
      const keys = checkedNodes
        .filter((nodes) => {
          return nodes.extData.isLastLevel
        })
        .map((nodes) => {
          return nodes.key
        })
      setSelectedIds(keys)
    }
  }

  return (
    <SearchTree
      data={treeData}
      otherTitle={otherTitle}
      titleLength={titleLength}
      label="title"
      ckey="objectId"
      showLine={false}
      checkable={checkable}
      checkedKeys={selectedIds}
      onCheck={onCheck}
      selectable={selectable}
      onSelect={(key, node) => {
        const { isLastLevel, label, lnglat } = node.node.extData || {}
        setClickedInfo({
          ...clickedInfo,
          clickedId: key[0] || null,
          isFirstLevel: node.node.level === 1,
          isLastLevel,
          selectedKeys: key,
          label,
          lnglat: lnglat || null,
        })
      }}
      selectedKeys={selectedKeys}
      setExtData={(item) => {
        return {
          isLastLevel: item.children.length === 0,
          label: item.parentsName.join('-'),
          parentsId: item.parentsId,
          lnglat: item.lnglat,
        }
      }}
      icon={(item) => {
        return item.icon || null
      }}
      checkStrictly={checkStrictly}
    />
  )
}

export default LeftTree
